export default {
  en: {
    back: 'Back',
    backToSpecialOfferList: 'Back to special offer list',
    previewSpecialOffer: 'Preview Special Offer',
    saveDraft: 'Save Draft',
    createSpecialOfferSuccessTitle: 'Success',
    createSpecialOfferSuccessMessage: 'Create Special Offer Success.'
  },
  th: {
    back: 'กลับ',
    backToSpecialOfferList: 'กลับไปหน้ารายการข้อเสนอพิเศษ',
    previewSpecialOffer: 'ดูตัวอย่างขอเสนอพิเศษ',
    saveDraft: 'บันทึกฉบับร่าง',
    createSpecialOfferSuccessTitle: 'สำเร็จ',
    createSpecialOfferSuccessMessage: 'สร้างข้อเสนอพิเศษสำเร็จ.'
  }
}
